import { motion } from "framer-motion";
import React from "react";
import { container, item } from "./animation";
import { Github } from "./Icons/Github";
import { ImageComp } from "./ImageComp";

function DevShow({ nodes }) {
  return (
    <>
      <div className="dev--show--wrapper">
        <motion.ul
          className="dev--lists"
          variants={container}
          initial="initial"
          animate="animate"
        >
          {nodes.map((n) => {
            return (
              <motion.li
                key={n.id}
                variants={item}
                exit={{
                  y: 100,
                  opacity: 0,

                  transition: { duration: 0.4 },
                }}
              >
                <div className="thumbnail--area">
                  <ImageComp
                    image={n.banner}
                    alt={`${n.title} website thumbnail`}
                  />
                </div>
                <div className="bottom--area">
                  <div className="title--area">
                    <h2>{n.title}</h2>
                    <p>{n.body.body}</p>
                  </div>
                  <div className="site--wrapper">
                    <a
                      href={n.livesite}
                      target="_blank"
                      rel="noOpener noReferrer"
                      className="live--site"
                    >
                      live site
                    </a>
                    <a
                      href={n.repo}
                      target="_blank"
                      rel="noOpener noReferrer"
                      className={n.repo === "no" ? "hide" : "show"}
                    >
                      <Github />
                    </a>
                  </div>
                </div>
              </motion.li>
            );
          })}
        </motion.ul>
      </div>
    </>
  );
}

export { DevShow };
